<div *ngFor="let item of selectApplianceTypes | keyvalue">
    <h6 class="header_title mb-3">{{ applianceMap[item.key].readableName}}</h6>
    <div class="row">
        <div class="col-3" *ngFor="let i of item.value | keyvalue">
            <img src="{{ applianceMap[item.key][i.key].imageUrl }}" alt="" class="img-fluid appliance__image" (click)="toggleAppliance(item.key, i.key)" />
            <br />

            <small class="appliance__text" *ngIf="i.value.selected === false">
         {{applianceMap[item.key][i.key].readableName}}
        </small>
            <small class="appliance__text text-danger" *ngIf="i.value.selected === true">
        {{ applianceMap[item.key][i.key].readableName }}</small
      >
    </div>
  </div>
</div>